 const delay = 3000; //ms

const ReviewReviewSlides = document.querySelector(".ReviewReviewSlides");
const iframe  = document.getElementsByClassName("ReviewSlide");
const ReviewReviewSlidesCount = ReviewReviewSlides.childElementCount;
const maxLeft = (ReviewReviewSlidesCount - 1) * 100 * -1;
var slidenumber=0;
let current = 0;
 setHeight(slidenumber);
function changeReviewSlide(next = true) {
  if (next) {
    current += current > maxLeft ? -100 : current * -1;
  } else {
    current = current < 0 ? current + 100 : maxLeft;
  }
 
  ReviewReviewSlides.style.left = current + "%";

  
 
  setHeight(slidenumber);
}

 function setHeight(num){
   console.log("here");
  var heightq= parseInt( iframe[slidenumber].height);
    
      iframe[slidenumber].height=heightq;
          document.getElementsByClassName('ReviewReviewSlides')[0]  .style.maxHeight=(heightq+10)+"px";
      document.getElementsByClassName('ReviewCarousel')[0] .style.maxHeight=(heightq+20)+"px";
 } 

// ReviewReviewControls
document.querySelector(".next-ReviewSlide").addEventListener("click", function() {
  if(slidenumber>=ReviewReviewSlidesCount-1){slidenumber=0;}else{slidenumber=slidenumber+1;}
  changeReviewSlide();
  // restart();
});

document.querySelector(".prev-ReviewSlide").addEventListener("click", function() {
  if(slidenumber==0){slidenumber=ReviewReviewSlidesCount-1;}else{slidenumber=slidenumber-1;}

  changeReviewSlide(false);
  // restart();
});